export default __webpack_public_path__ + "static/media/Internal_data_sec_policies.aa2ea908.png";